import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Tab, Tabs, ListGroup, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { FaUser, FaCar, FaHistory, FaMapMarkerAlt, FaEdit } from 'react-icons/fa';

const UserProfilePage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('profile');
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // In a real app, you would get the user ID from auth context
        const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/users/1');
        setUser(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container className="py-5">
        <Card>
          <Card.Body className="text-center">
            <h4>User not found</h4>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <Row>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body className="text-center">
              <div className="position-relative">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Profile"
                  className="rounded-circle mb-3"
                  width="150"
                  height="150"
                />
                <Button 
                  variant="light" 
                  size="sm" 
                  className="position-absolute top-0 end-0 rounded-circle"
                  style={{ width: '40px', height: '40px' }}
                >
                  <FaEdit />
                </Button>
              </div>
              <h4>{user.username}</h4>
              <p className="text-muted mb-4">{user.email}</p>
              
              <Button variant="primary" className="me-2">Edit Profile</Button>
              <Button variant="outline-secondary">Change Password</Button>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <h5 className="d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                Address
              </h5>
              <p className="text-muted">
                123 Main St<br />
                New York, NY 10001<br />
                United States
              </p>
              <Button variant="outline-primary" size="sm">Edit Address</Button>
            </Card.Body>
          </Card>
        </Col>

        <Col md={8}>
          <Card>
            <Card.Body>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-4"
              >
                <Tab eventKey="profile" title={<><FaUser className="me-2" />Profile</>}>
                  <div className="mt-4">
                    {editMode ? (
                      <Form>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group controlId="username">
                              <Form.Label>Username</Form.Label>
                              <Form.Control type="text" defaultValue={user.username} />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group controlId="email">
                              <Form.Label>Email</Form.Label>
                              <Form.Control type="email" defaultValue={user.email} />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group controlId="phone">
                              <Form.Label>Phone</Form.Label>
                              <Form.Control type="tel" defaultValue={user.contact_details} />
                            </Form.Group>
                          </Col>
                        </Row>
                        <div className="d-flex justify-content-end">
                          <Button variant="secondary" className="me-2" onClick={() => setEditMode(false)}>
                            Cancel
                          </Button>
                          <Button variant="primary">
                            Save Changes
                          </Button>
                        </div>
                      </Form>
                    ) : (
                      <>
                        <ListGroup variant="flush">
                          <ListGroup.Item>
                            <div className="d-flex justify-content-between">
                              <span>Username</span>
                              <span className="fw-bold">{user.username}</span>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <div className="d-flex justify-content-between">
                              <span>Email</span>
                              <span className="fw-bold">{user.email}</span>
                            </div>
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <div className="d-flex justify-content-between">
                              <span>Contact</span>
                              <span className="fw-bold">{user.contact_details || 'Not provided'}</span>
                            </div>
                          </ListGroup.Item>
                        </ListGroup>
                        <div className="mt-3 text-end">
                          <Button variant="outline-primary" onClick={() => setEditMode(true)}>
                            <FaEdit className="me-2" />
                            Edit Profile
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </Tab>
                <Tab eventKey="vehicles" title={<><FaCar className="me-2" />My Vehicles</>}>
                  <div className="mt-4">
                    <h5>Your Listed Vehicles</h5>
                    <p className="text-muted">You haven't listed any vehicles yet.</p>
                    <Button variant="primary">List a Vehicle</Button>
                  </div>
                </Tab>
                <Tab eventKey="history" title={<><FaHistory className="me-2" />Order History</>}>
                  <div className="mt-4">
                    <h5>Your Order History</h5>
                    <p className="text-muted">You haven't placed any orders yet.</p>
                  </div>
                </Tab>
              </Tabs>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UserProfilePage;